"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _bookingJapan = require("@/api/bookSpace/bookingJapan");
var _index = _interopRequireDefault(require("@/components/Transfer/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "voyageDetails",
  components: {
    Transfer: _index.default,
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    voyagePlanJpVo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      targetDataOne: [],
      sourceData: [],
      tableKey: 0,
      transferDialogVisible: false,
      listQuery: {
        currentPage: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      form: {},
      hotSettings: {
        dragCheck: true,
        height: 'calc(50vh - 215px)',
        width: 'auto',
        overflow: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    this.initData();
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.resizeHotTable();
    });
  },
  methods: {
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    initData: function initData() {
      var _this2 = this;
      this.sourceData = [{
        data: 'portCode',
        title: this.$t('booking.bookingJapan.port')
      }, {
        data: 'eta',
        title: 'ETA'
      }, {
        data: 'cy',
        title: 'CY'
      }];
      this.targetDataOne = [];
      this.tableKey += 1;
      this.$refs.transfer && this.$refs.transfer.initData(this.sourceData, this.targetDataOne);
      this.$nextTick(function () {
        _this2.handleSearch();
      });
    },
    handleSortOpen: function handleSortOpen() {
      console.log('this.sourceData', this.sourceData);
      this.transferDialogVisible = true;
    },
    handleSubimtSort: function handleSubimtSort(data) {
      console.log('data', data);
      this.transferDialogVisible = false;
      this.sourceData = data;
      this.tableKey += 1;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this3 = this;
      var data = this.voyagePlanJpVo;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      (0, _bookingJapan.searchVoyage)(data).then(function (res) {
        console.log(res);
        if (res.success) {
          _this3.tableData = res.data.records;
          _this3.total = res.data.totalRecord;
        } else {
          _this3.$message.error(res.errorMessages[0]);
        }
      });
    },
    opened: function opened() {
      console.log("aaaaaaa");
      this.handleSearch();
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleClose: function handleClose() {
      this.closed();
    },
    closed: function closed() {
      this.$emit('update:visible', false);
    }
  }
};